import React, { useEffect, useState} from "react";
import {CommonResult, ListResult, UserInfo, UserQueryParams, UserSiteInfo} from "../../type/type";
import {
    aesCBCDecrypt, aesCBCEncrypt, getUserImageUrl,
    NoParentDataText,
    ROLE_PARENT,
} from "../../utils/commonUtils";
import {deleteUserHandler, getUser, userApproval} from "../../api/api";
import Loading from "components/Loading";
import {OutlinePrimaryBtn, SolidPrimarySubBtn, SolidRedBtn} from "components/button/Button";
import {EllipsisTextColumn, FlexGrow, ListContentWrap, PageArticleWrap, PageHeaderTitleButtonStyle} from "components/layout/Layout";
import styled from "styled-components";
import {NoDataWithImageText} from "components/NoDataComponent";
import {RoundBigImage, RoundImageContainer} from "components/common/Image";
import { RoundIcon } from "components/common/Icon";
import { CustomCheckbox } from "components/input/Input";
import { FlexWrapR } from "components/common/CommonLayout";
import { useRecoilValue } from "recoil";
import { selectSiteIdState } from "styles/atoms";

const ArticleWrap = styled.div`
    width: 100%;
    // height: calc(100% - 5.75rem); // 이름 검색 API 추가 시
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;

const FilterContainer = styled.nav`
  background-color: ${({theme}) => theme.rootWhite};
  padding: 1rem;
  border-radius: 0.5rem;
  display: flex;
  flex-direction: row;
  gap: 2rem;
`;

const FilterWrap = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  min-width: 12.5rem;
  > div {
    width: 100%;
  }
`;

const TableColumn = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${({theme}) => theme.newTheme.border.primaryBd};
  > div {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 1rem;
  }
  .thumbnail-wrap {
    max-height: 5rem;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  &:hover {
    background-color: ${({theme}) => theme.newTheme.table.tableBodyHoverBg};
  }
    .flex-end {
        justify-content: end;
        gap: 0.25rem 0.5rem;
    }
`;

const NoDataWrap = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
`
// 테이블 위 버튼 wrap
const JoinNavWrap = styled.nav`
    display:flex;
    flex-direction: row;
    align-items: center;
    gap: 1rem;
`;

const CheckBoxWrap = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    margin-left: auto;
`;

interface ParentListViewerProps{
    parentList: UserInfo[];
    setIsUpdateAllApproval: (value:boolean) => void;
    waitApproval: number;
    allSelectParentCheck: boolean;
    selectParentIdList: number[];
    setAllSelectParentCheck: (value:boolean) => void;
    handleSelectParentId: (parentId:number) => void;
    handleAllSelectParentId: () => void;
    updateApproval: (userId:number,approval:number) => void;
    deleteParent: (userId:number) => void;

}

const ParentListViewer: React.FC<ParentListViewerProps> = ({ parentList,
                                                            setIsUpdateAllApproval,
                                                            waitApproval,
                                                            allSelectParentCheck,
                                                            selectParentIdList,
                                                            setAllSelectParentCheck,
                                                            handleSelectParentId,
                                                            handleAllSelectParentId,
                                                            updateApproval,
                                                            deleteParent }) => {
    
    //승인완료 숨기기 체크박스 상태
    const [allApprovalCheck, setAllApprovalCheck] = useState<boolean>(false);

    /**
     * 일괄 승인 요청
     */
    const updateAllApproval = async () => {

        try{
            if(selectParentIdList.length <= 0){
                alert("선택된 학부모가 없습니다.");
                return;
            }

            //선택한 학부모 중 승인 대기인 학부모만 추출
            const approvalParentList:UserInfo[] = parentList.filter((parent:UserInfo) =>
                selectParentIdList.includes(parent.id) && (parent.approval === 0 || parent.approval === 2)
            );

            if(approvalParentList.length <= 0){
                alert("선택된 학부모 중 승인 대기인 학부모가 없습니다.");
                return;
            }

            const allRequest = approvalParentList.map(async (parent:UserInfo ) => {
                const res: CommonResult = await userApproval(parent.id, 1);
            });

            await Promise.all(allRequest);
            alert("승인 요청이 완료되었습니다.");
            setIsUpdateAllApproval(true);
        }
        catch (e) {
            console.error(e);
        }

    }

    useEffect(() => {
        //모든 학부모가 선택되었을때, all 체크박스 체크
        if (parentList.length > 0 && selectParentIdList.length === parentList.length) {
            setAllSelectParentCheck(true);
        } else {
            setAllSelectParentCheck(false);
        }
    }, [selectParentIdList, setAllSelectParentCheck, parentList]);

    return (
        <ListContentWrap style={{gap: '0.5rem', height: '100%'}}>
            <JoinNavWrap>
                <p>
                    <span>전체: <RoundIcon type="disabled" text={`${parentList.length}`} /> 건 / </span>
                    <span>승인대기: <RoundIcon type="waiting" text={`${waitApproval}`} /> 건</span>
                </p>
                <CheckBoxWrap>
                    <CustomCheckbox id="all-approval" type="checkbox"
                                    onClick={() => {setAllApprovalCheck(!allApprovalCheck)}} checked={allApprovalCheck}/>
                    <label htmlFor="all-approval">승인완료 숨기기</label>
                </CheckBoxWrap>
                <OutlinePrimaryBtn type="button" onClick={updateAllApproval}>
                    일괄 승인
                </OutlinePrimaryBtn>
            </JoinNavWrap>
            <div className="list-one-wrap h100">
                <div className="list-table">
                    <div>
                        <nav className="list-table-header">
                            <FlexWrapR className="w-5" $justifyContent="center" $alignItems="center">
                                <CustomCheckbox type="checkbox"
                                                checked={allSelectParentCheck}
                                                onClick={handleAllSelectParentId}/>
                            </FlexWrapR>
                            <div className="w-12">사진</div>
                            <FlexGrow className="w-15">이름</FlexGrow>
                            <div className="w-15">아이디</div>
                            <FlexGrow className="w-15">자녀 이름</FlexGrow>
                            <div className="w-15">연락처</div>
                            <div className="w-20">승인 상태</div>
                        </nav>

                        {/*학부모 리스트 출력 + approval 정렬 */}
                        {parentList.sort((a, b) => a.approval - b.approval).map((parent:UserInfo,index)  => {
                            // 승인완료 숨기기
                            if(allApprovalCheck && parent.approval === 1){
                                return null;
                            }
                            let approvalText = "";
                            let approvalColor = "";

                            switch (parent.approval) {
                                case 0:
                                    approvalText = "승인 대기";
                                    approvalColor = "text-yellow";
                                    break;
                                case 1:
                                    approvalText = "승인 완료";
                                    approvalColor = "text-gray";
                                    break;
                                case 2:
                                    approvalText = "승인 거절";
                                    approvalColor = "text-red";
                                    break;
                            }

                            return (
                                <TableColumn key={parent.id}>
                                    <FlexWrapR className="w-5" $justifyContent="center" $alignItems="center">
                                        <CustomCheckbox type="checkbox"
                                                        value={parent.id}
                                                        checked={selectParentIdList.includes(parent.id)}
                                                        onClick={() => {
                                                            handleSelectParentId(parent.id)
                                                        }}/>
                                    </FlexWrapR>
                                    <RoundImageContainer className="w-12">
                                        <RoundBigImage src={parent.image_url} alt="profile"/>
                                    </RoundImageContainer>
                                    <FlexGrow className="w-15">
                                        <EllipsisTextColumn>{aesCBCDecrypt(parent.name)}</EllipsisTextColumn>
                                    </FlexGrow>
                                    <div className="w-15">{ parent.login_id} </div>
                                    {/*//자녀 학생 이름 1번째만 출력*/}
                                    <FlexGrow className="w-15">
                                        <EllipsisTextColumn>{parent.student_list.length > 0 ? aesCBCDecrypt(parent.student_list[0].name) : ""}</EllipsisTextColumn>
                                    </FlexGrow>
                                    <div className="w-15">{parent.phone ? aesCBCDecrypt(parent.phone) : ""}</div>
                                    <div className="w-20 flex-end">
                                        <span style={{fontWeight: 'bold'}} className={approvalColor}>{approvalText}</span>

                                        {parent.approval === 0 ? (
                                            <>
                                                <SolidPrimarySubBtn className="little-btn" onClick={() => updateApproval(parent.id, 1)}>
                                                    승인
                                                </SolidPrimarySubBtn>
                                                <SolidRedBtn className="little-btn" onClick={() => updateApproval(parent.id, 2)}>
                                                    거절
                                                </SolidRedBtn>
                                            </>
                                        ) : (
                                            //이미 승인 완료/거절된 상태라면 승인 버튼 비활성화, 거절 -> 삭제
                                            <>
                                                <OutlinePrimaryBtn className="little-btn" disabled>승인</OutlinePrimaryBtn>
                                                <SolidRedBtn className="little-btn" onClick={() => deleteParent(parent.id)}>삭제</SolidRedBtn>
                                            </>
                                        )}
                                    </div>

                                </TableColumn>
                            )
                        })}

                    </div>
                </div>
            </div>
        </ListContentWrap>
    )
}

export const ParentManagement = () => {

    // 전역 변수
    const selectSiteId = useRecoilValue(selectSiteIdState);

    const [loading, setLoading] = useState<boolean>(true);

    //학부모 정보 목록
    const [parentList, setParentList] = useState<UserInfo[]>([]);

    //승인대기 건수
    const [waitApproval, setWaitApproval] = useState(0);

    //모든 학부모 ID 체크박스
    const [allSelectParentCheck, setAllSelectParentCheck] = useState<boolean>(false);

    //목록 학부모 ID 체크박스
    const [selectParentIdList, setSelectParentIdList] = useState<number[]>([]);

    //일괄 승인 클릭 여부 - 학부모 목록 새로고침용
    const [isUpdateAllApproval, setIsUpdateAllApproval] = useState(false);

    //사용자 API 파라미터
    const [userQueryParams, setUserQueryParams] = useState<UserQueryParams>({
        site_id: selectSiteId,
        name: "",
        page: 1,
        size: 1000,
        class_id: 0,
        role: ROLE_PARENT,
        role_number: 0,
        student_name: ""
    });

    // 학부모 목록 조회 파라미터 변경
    function changeStudentQueryParams(updates: Partial<UserQueryParams>) {
        setUserQueryParams((prev) => {
            return {...prev, ...updates}
        });
    }
    
    //학생명으로 검색
    function handleStudentNameSearch(name:string){

        if(!name){
            changeStudentQueryParams({
                name:""
            });
            return;
        }
        //학생 이름 암호화
        changeStudentQueryParams({name:aesCBCEncrypt(name)});
    }

    /**
     * 단일 승인 요청
     * @param userId
     * @param approval
     */
    const updateApproval = async (userId:number,approval:number) => {
        try{
            const res:CommonResult = await userApproval(userId,approval);
            if(res.code === 200) {
                let title = "승인이 완료되었습니다.";
                if(approval === 2){
                    title = "승인이 거절되었습니다.";
                }

                alert(title);
                getParentList();
            }
        }
        catch (e) {
            console.error(e);
        }
    };

    const handleSelectParentId = (parentId:number) => {
        //이미 체크된 학부모 ID라면 체크 해제
        if(selectParentIdList.includes(parentId)){
            setSelectParentIdList(selectParentIdList.filter((id) => id !== parentId));
        }
        //체크되지 않은 학부모 ID라면 체크
        else{
            setSelectParentIdList([...selectParentIdList, parentId]);
        }
    }

    //모든 학부모 체크
    const handleAllSelectParentId = () => {
        //모든 학부모 체크 해제
        if(selectParentIdList.length === parentList.length){
            setSelectParentIdList([]);
        }
        //모든 학부모 체크
        else{
            const parentIdList = parentList.map((parent) => parent.id);
            setSelectParentIdList(parentIdList);
        }
    }

    /**
     * 단일 삭제 요청
     * @param userId
     */
    const deleteParent = async (userId:number) => {
        try {
            
            const isDelete = window.confirm('해당 학부모를 삭제하시겠습니까?');

            if (isDelete) {
                const res: CommonResult = await deleteUserHandler(userId);

                if (res.code === 200) {
                    alert('삭제 완료됐습니다.');
                    getParentList();
                }
            }
            
        }
        catch (e) {
            console.error(e);
        }
    };


    const getParentList = async () => {
        setLoading(true);
        //API 호출
        const res:ListResult<UserInfo> = await getUser(userQueryParams);
        if (res.code === 200) {
            
            const parentList: UserInfo[] = res.data;
            
            let cnt = 0; // 승인대기 cnt
            for(const parent of parentList){
                const userSite:UserSiteInfo|undefined = parent.user_site_list.find((userSite) => userSite.site_id === selectSiteId);
                const approval = userSite?.approval;
                const approvalDate = userSite?.approval_date;
                parent.approval = approval || 0;
                parent.approval_date = approvalDate || "";

                let student: any[] = [];
                if (parent.student_list.length > 0) {
                    student = parent.student_list.filter(s => s.is_delete !== 1);
                }
                parent.student_list = student;

                if (!approval) cnt += 1;
            }
            //모든 학부모 이미지 URL 조회
            setParentList(await getUserImageUrl(parentList));

            setWaitApproval(cnt);
        }
        setLoading(false);
    }

    useEffect(() => {
        getParentList();
    }, []);

    useEffect(() => {
        if (isUpdateAllApproval) {
            getParentList();
            setIsUpdateAllApproval(false);
            setAllSelectParentCheck(false);
            setSelectParentIdList([]);
        }
        else return;
    }, [isUpdateAllApproval]);

    return (
        <>
            <PageHeaderTitleButtonStyle>
                <p className="header-title">학부모 정보</p>
            </PageHeaderTitleButtonStyle>
            <ArticleWrap>
                {/* 현재 학생 이름으로 학부모 조회 API 없음 */}
                {/* <FilterContainer>
                    <FilterWrap>
                        <label>학생</label>
                        <input type="text"
                                placeholder="학생 이름을 입력해주세요."
                                onChange={(e) => { handleStudentNameSearch(e.target.value) }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') getParentList();
                                }}
                        />
                    </FilterWrap>
                    <SolidPrimarySubBtn onClick={getParentList}>조회</SolidPrimarySubBtn>
                </FilterContainer> */}

                { loading ? <Loading/> : (
                    <PageArticleWrap>
                        <article className='list-content-container'>
                            <div className="article-header">
                                <p><span className="article-header-title">학부모 목록</span></p>
                            </div>
                            <ListContentWrap style={{gap: '0.5rem', height: 'calc(100% - 1.25rem - 0.5rem)'}}>
                            { parentList.length > 0 ? 
                                    <ParentListViewer parentList={parentList}
                                                    setIsUpdateAllApproval={setIsUpdateAllApproval}
                                                    waitApproval={waitApproval}
                                                    allSelectParentCheck={allSelectParentCheck}
                                                    selectParentIdList={selectParentIdList}
                                                    setAllSelectParentCheck={setAllSelectParentCheck}
                                                    handleSelectParentId={handleSelectParentId}
                                                    handleAllSelectParentId={handleAllSelectParentId}
                                                    updateApproval={updateApproval}
                                                    deleteParent={deleteParent} />
                                :
                                <NoDataWrap>
                                    <NoDataWithImageText text={NoParentDataText}/>
                                </NoDataWrap>
                            }
                            </ListContentWrap>
                        </article>
                    </PageArticleWrap>
                )}
            </ArticleWrap>
        </>
    )
}